import(/* webpackMode: "eager" */ "/tmp/8de6424b7068bf1/app/[locale]/error.tsx");
